module.exports = __webpack_public_path__ + "img/1503960655.a49ab0cd.jpg";